import { render, staticRenderFns } from "./ProcessHistory.vue?vue&type=template&id=33396470&scoped=true&"
import script from "./ProcessHistory.vue?vue&type=script&lang=js&"
export * from "./ProcessHistory.vue?vue&type=script&lang=js&"
import style0 from "./ProcessHistory.vue?vue&type=style&index=0&id=33396470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33396470",
  null
  
)

export default component.exports